import { Fragment, useState } from "react";
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { AccountTableColumn } from "./accountColumns";
import { AccountTableRow } from "./accountRows";
import { helperConstants as constants } from "../../../helpers/helperConstants";
import Link from "next/link";
import moment from "moment";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";

const AccountTableRow = ({
  columns,
  row,
}: {
  columns: AccountTableColumn[];
  row: AccountTableRow;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
        {columns.map((column) => {
          const value = row[column.id];
          return (
            <TableCell
              key={column.id}
              align={column.align}
              classes={{
                root: "dark:border-jacarta-100 border-jacarta-100 dark:text-white text-jacarta-700 dark:bg-jacarta-600 bg-jacarta-50",
              }}
            >
              {column.id === "collapsible" ? (
                row.offer?.isGlobal &&
                row.offer?.filledGlobalLendOffers?.length > 0 ? (
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpen(!open)}
                  >
                    {open ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                  </IconButton>
                ) : null
              ) : column.format && typeof value === "number" ? (
                column.format(value)
              ) : (
                value
              )}
            </TableCell>
          );
        })}
      </TableRow>
      {row.offer?.isGlobal && row.offer?.filledGlobalLendOffers?.length > 0 && (
        /* open && */ <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, border: 0 }}
            colSpan={columns.length}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <FilledOffers
                filledGlobalLendOffers={row.offer.filledGlobalLendOffers}
              />
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </Fragment>
  );
};

const FilledOffers = ({
  filledGlobalLendOffers,
}: {
  filledGlobalLendOffers: any[];
}) => {
  return (
    <Table size="small" aria-label="filledoffers">
      <TableHead>
        <TableRow>
          {[
            `NFT${filledGlobalLendOffers.length > 1 ? "s" : ""}`,
            "From",
            "Start Time",
          ].map((column) => (
            <TableCell
              key={column}
              classes={{
                root: "dark:border-jacarta-100 border-jacarta-100 dark:text-white text-jacarta-700 dark:bg-jacarta-600 bg-jacarta-50",
              }}
            >
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {filledGlobalLendOffers.map((filledGlobalLendOffer) => (
          <TableRow key={filledGlobalLendOffer.id}>
            <TableCell
              classes={{
                root: "dark:border-jacarta-100 border-jacarta-100 dark:text-white text-jacarta-700 dark:bg-jacarta-600 bg-jacarta-50",
              }}
            >
              {filledGlobalLendOffer.colleteralTokenID}
            </TableCell>
            <TableCell
              classes={{
                root: "dark:border-jacarta-100 border-jacarta-100 dark:text-white text-jacarta-700 dark:bg-jacarta-600 bg-jacarta-50",
              }}
            >
              <Link
                href={`${constants?.helpers?.marketplace_url}/user/${filledGlobalLendOffer.issuer}`}
              >
                <a target={"_blank"} className="text-accent">
                  {filledGlobalLendOffer.issuer.slice(0, 4) +
                    "..." +
                    filledGlobalLendOffer.issuer.slice(-4)}
                </a>
              </Link>
            </TableCell>
            <TableCell
              classes={{
                root: "dark:border-jacarta-100 border-jacarta-100 dark:text-white text-jacarta-700 dark:bg-jacarta-600 bg-jacarta-50",
              }}
            >
              <div className="flex items-center">
                {moment(Number(filledGlobalLendOffer.startTime) * 1000)
                  .format("DD/MM/YYYY - HH:mm")
                  .toString()}
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default AccountTableRow;
